import type { WavesChart } from '../wavesChart.js';
import type { Variant } from '../gameTypes.js';
import { PALETTE_CYAN } from '../builtinPulseMaps/palettes.js';
import { assembleWavesChartFromCircles } from './wavesFromCircles.js';
import audioOnsets from '../circlesBuiltinMaps/audio/sky-high.onsets.json' with { type: 'json' };
import normalImported from '../circlesBuiltinMaps/imported/sky-high-normal.circles.json' with { type: 'json' };
import hardImported from '../circlesBuiltinMaps/imported/sky-high-hard.circles.json' with { type: 'json' };
import extremeImported from '../circlesBuiltinMaps/imported/sky-high-extreme.circles.json' with { type: 'json' };

export const SKY_HIGH_WAVES_VARIANTS: Record<Variant, WavesChart> = assembleWavesChartFromCircles({
  baseSlug: 'sky-high',
  baseTitle: "Sky High",
  description: "Anthemic progressive house from Elektronomia. Four-on-the-floor groove, wave-mode glide.",
  difficulty: 2,
  palette: PALETTE_CYAN,
  audioSrc: '/audio/waves/sky-high.mp3',
  attribution: "\"Sky High\" by Elektronomia [NCS Release] - https://ncs.io/SkyHigh",
  mapper: "Facundo Yoel",
  anchorOnsets: audioOnsets,
  imported: {
    normal: normalImported,
    hard: hardImported,
    extreme: extremeImported,
  },
  timing: {
    normal: { bpm: 118.72, offsetMs: 0, totalBeats: 121 },
    hard: { bpm: 118.72, offsetMs: 0, totalBeats: 121 },
    extreme: { bpm: 118.72, offsetMs: 0, totalBeats: 121 },
  },
});
